import { EventEmitter, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { NetaxeptRepository } from "../infrastructure/repositories/netaxept.repository";
import { NetaxeptFinalizeResponse } from "../model/interfaces/netaxept-finalize-response";
import { NetaxeptRegisterPaymentResponse } from "../model/interfaces/netaxept-register-payment-response";
import { Order } from "../model/interfaces/order";

@Injectable({providedIn: 'root'})
export class NetaxeptService
{
    public onNetaxeptPaymentCompleted = new EventEmitter<Order>();

    private readonly netaxeptRepository: NetaxeptRepository;

    public constructor(netaxeptRepository: NetaxeptRepository) 
    {
        this.netaxeptRepository = netaxeptRepository;
    }

    public registerPayment(orderId: number, description: string, context: string, mobilePay: boolean): Observable<NetaxeptRegisterPaymentResponse> // TODO: replace "any" return type.
    {
        return this.netaxeptRepository.registerPayment(orderId, description, context, mobilePay);
    }

    public paymentCompleted(order: Order): void
    {
        this.onNetaxeptPaymentCompleted.emit(order);
    }

    public finalizeTransaction(transactionId: string) : Observable<NetaxeptFinalizeResponse>
    {
        return this.netaxeptRepository.finalizeTransaction(transactionId);
    }
}
